import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { toast } from "react-toastify";

const tooltipSlotProps = {
  tooltip: { sx: { maxWidth: 420, userSelect: "text", cursor: "text" } },
};

const SigningLinkTooltip = ({ url }) => (
  <Box>
    <Typography variant="caption" component="div" sx={{ fontWeight: 600 }}>
      Copy signing link
    </Typography>
    <Typography variant="caption" component="div" sx={{ wordBreak: "break-all" }}>
      {url}
    </Typography>
  </Box>
);

const CopySigningLinkButton = ({ url }) => {
  if (!url) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Signing link copied");
    } catch {
      toast.error("Could not copy the link");
    }
  };

  return (
    <Tooltip title={<SigningLinkTooltip url={url} />} slotProps={tooltipSlotProps}>
      <IconButton size="small" aria-label="Copy signing link" onClick={handleCopy}>
        <ContentCopyOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default CopySigningLinkButton;
